import { render, staticRenderFns } from "./draggable-float.vue?vue&type=template&id=27d1f6f8&scoped=true&"
import script from "./draggable-float.vue?vue&type=script&lang=js&"
export * from "./draggable-float.vue?vue&type=script&lang=js&"
import style0 from "./draggable-float.vue?vue&type=style&index=0&lang=css&"
import style1 from "./draggable-float.vue?vue&type=style&index=1&id=27d1f6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1f6f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
